'use client'

import React from 'react'
import Image from 'next/image'
import { ContinueInsureCardProps } from '@interfaces/giCar'
import styles from '../GICarLanding.module.scss'

const ContinueInsureCard: React.FC<ContinueInsureCardProps> = ({
  item,
  onClick,
  className,
  style,
  formatPremium,
  index,
  vehicleTypeLabel = 'car',
}) => (
  <div
    key={item?.redirect_link || item?.proposal_id || index}
    className={`${styles.continueInsureCard} ${className || ''}`}
    onClick={() => onClick(item)}
    style={style}>
    <div className={styles.vehicleImageWrapper}>
      <Image
        src={item?.logo_url}
        alt={item?.mmv?.model || vehicleTypeLabel}
        width={60}
        height={40}
        className={styles.vehicleThumbnail}
      />
    </div>
    <div className={styles.renewalContent}>
      <p className={styles.renewalVehicleInfo}>
        {`${item?.make || item?.mmv?.make || ''} ${item?.model || item?.mmv?.model || ''}`.trim() || vehicleTypeLabel} •{' '}
        {item?.registration_number || ''}
      </p>
      <p className={styles.renewalExpiryText}>
        Continue insuring your {vehicleTypeLabel}, starting at {formatPremium(item?.net_premium)}.
      </p>
    </div>
    <div className={styles.renewalArrowButton}>
      <svg
        className={styles.arrowIcon}
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.0001 17L20 12L15 7"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"></path>
        <path
          d="M4 12H20"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"></path>
      </svg>
    </div>
  </div>
)

export default ContinueInsureCard
